


















import Vue, { PropType } from 'vue';
import WidgetWrapper from '@/components/widgets/WidgetWrapper.vue';
import { AudiencesData } from '@/types/campaign/targets';
import SelectChipsFromRightSlide from '@/components/chips/SelectChipsFromRightSlide.vue';
import { Audience } from '@/types/audience/audience';

export default Vue.extend({
  name: 'TheAudiences',
  components: { WidgetWrapper, SelectChipsFromRightSlide },

  props: {
    data: {
      type: Object as PropType<AudiencesData>,
      required: true,
    },
  },

  async mounted() {
    await this.$store.dispatch('audience/audiencesList', {
      searchData: {},
      columns: ['id', 'name'],
    });
  },

  computed: {
    audiences(): Array<Audience> {
      return this.$store.getters['audience/getAudiencesList'].map(audience => {
        return {
          id: audience.id,
          name: audience.name,
          parent_id: audience.id,
          value: audience.id.toString(),
        };
      });
    },
  },

  methods: {
    changeCategoryList(audiencesList) {
      this.$emit('changeCampaign', 'audiences', audiencesList);
      return;
    },
  },
});
